<template>
  <div>
    <v-card v-for="item in list" :key="item.id" class="my-2">
      <v-card-subtitle>
        <div class="d-flex justify-space-between">
          <span class="news-title">
            {{ item.lastname }} {{ item.firstname }} {{ item.date_create }}
          </span>

          <v-icon v-if="item.settings && item.settings.minimize" class="cursor-pointer" @click="maximizeMessage(item)"
            icon="mdi-arrow-expand"></v-icon>
          <v-icon v-else class="cursor-pointer" @click="minimizeMessage(item)"
            icon="mdi-arrow-collapse"></v-icon>

        </div>
      </v-card-subtitle>

      <v-card-text class="announce-message" style="position: relative;">
        <div v-html="item.text_mess" :style="(item.settings && item.settings.minimize) ? 'max-height:50px' : ''"></div>
        <div v-if="item.settings && item.settings.minimize" class="blur-long-text"></div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "announceList",
  props: {
    list: {
      required: true,
    },
  },
  data() {
    return {};
  },
  created() { },
  methods: {
    minimizeMessage(item) {
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/psm_desktop2/minimizeMessage",
          new URLSearchParams({
            id: item.id,
          })
        )
        .then((response) => {
        })
        .catch((error) => {
          console.log(error);
        });
      if(!item.settings){
        item.settings={}
      }
      item.settings.minimize=1;
    },
    maximizeMessage(item) {
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/psm_desktop2/maximizeMessage",
          new URLSearchParams({
            id: item.id,
          })
        )
        .then((response) => {
        })
        .catch((error) => {
          console.log(error);
        });
      if(!item.settings){
        item.settings={}
      }
      item.settings.minimize=0;
    }
  },
};
</script>
<style lang="scss">
#procollege_desktop2 {
  .news-title {
    font-style: italic;
    color: #535d6c;
  }

  .announce-message p {
    margin: 0;
  }

  .blur-long-text {
    background: linear-gradient(rgba(255, 255, 255, 0), rgb(255, 255, 255));
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
  }
}
</style>
